<nav
  class="sidebar bg-teal7 text-teal2 d-flex flex-column h-100"
  [class.collapsed]="!sideMenuIsExpanded()"
  [class.legacy-header]="!headerService.withHeader()"
  [@toggleSideNav]="sideMenuIsExpanded() ? 'nav-expanded' : 'nav-collapsed'"
>
  <div class="flex-grow-1 d-flex flex-column overflow-y-auto">
    <div id="application-section" class="flex-grow-1" [class.pt-4]="headerService.withHeader()">
      <div id="mods-for-current-org">
        <ng-container
          [ngTemplateOutlet]="orderedMods"
          [ngTemplateOutletContext]="{
            mods: e360UserService.modulesForCurrentOrg
          }"
        ></ng-container>
      </div>
      @if (e360UserService.modulesForDifferentOrg?.length) {
        <div class="mt-3" id="mods-for-diff-org">
          @if (sideMenuIsExpanded()) {
            <div class="d-flex align-items-center mx-3">
              <p class="m-0 text-teal3 fs-12 flex-grow-1">
                {{ (!e360UserService.isGlobalUser ? 'APPS_REQUIRE_AUTH' : 'APPS_FOR_SELECTED_ORG') | translate }}
              </p>
              <i
                [ngbTooltip]="
                  (!e360UserService.isGlobalUser ? 'AUTH_TOOLTIP' : 'APPS_SELECTED_ORG_TOOLTIP') | translate
                "
                container="body"
                class="fa-light fa-circle-info text-teal3"
                aria-hidden="true"
              ></i>
            </div>
          }
          <hr class="mt-2 mb-3 mx-3 text-teal3 opacity-100" />
          <ng-container
            [ngTemplateOutlet]="orderedMods"
            [ngTemplateOutletContext]="{
              mods: e360UserService.modulesForDifferentOrg
            }"
          ></ng-container>
        </div>
      }
    </div>
    <div id="user-section" class="pb-3">
      <hr class="text-teal3 opacity-100" />
      <div [triggers]="'hover'" [ngbTooltip]="sideMenuIsExpanded() ? '' : e360UserService.userFullName" placement="end">
        <div class="d-flex align-items-center flex-row p-2 mx-2" [class.mb-3]="!sideMenuIsExpanded()" placement="end">
          <div class="text-center" [ngClass]="sideMenuIsExpanded() ? '' : 'flex-grow-1'">
            <i class="fa-light fa-user fa-lg" aria-hidden="true"></i>
          </div>
          @if (sideMenuIsExpanded()) {
            <div class="ps-3">
              <span id="user-full-name">{{ e360UserService.userFullName }}</span>
            </div>
          }
        </div>
      </div>
      @if (e360UserService.adminModules?.length) {
        <div
          ngbDropdown
          id="admin-mods"
          placement="end"
          #adminDrop="ngbDropdown"
          tabindex="0"
          (focus)="adminDrop.open()"
          (mouseover)="adminDrop.open()"
          (blur)="adminDrop.close()"
          (mouseout)="adminDrop.close()"
          (keydown.enter)="adminDrop.close()"
          (click)="adminDrop.close()"
        >
          <div
            class="d-flex align-items-center flex-row p-2 mx-2 actionable"
            [class.mb-3]="!sideMenuIsExpanded()"
            [ngClass]="{ selected: navigationService.adminModuleActive() }"
            ngbDropdownToggle
          >
            <div ngbDropdownMenu>
              @for (m of e360UserService.adminModules; track m.id) {
                <div
                  role="link"
                  id="{{ m.displayName }}-link"
                  tabindex="0"
                  (click)="appClick.emit(m)"
                  (keydown.enter)="appClick.emit(m)"
                  class="d-flex align-items-center flex-row py-2 mx-2 text-teal2 actionable"
                  [ngClass]="{ selected: m.active }"
                >
                  <div class="flex-grow-1 d-flex align-items-center ps-2">
                    <span class="flex-grow-1">{{ m.displayName }}</span>
                    @if (
                      m.organizationId !== e360UserService.user.organizationId &&
                      m.organizationId !== e360SessionService.defaultOrganizationContext?.organizationId
                    ) {
                      <i
                        [ngbTooltip]="'AUTH_TOOLTIP' | translate"
                        container="body"
                        class="fa-light fa-circle-info text-teal3"
                        aria-hidden="true"
                      ></i>
                    }
                  </div>
                </div>
              }
            </div>
            <div class="text-center" [class.flex-grow-1]="!sideMenuIsExpanded()">
              <i class="fa-light fa-lg fa-screwdriver-wrench" aria-hidden="true"></i>
            </div>
            @if (sideMenuIsExpanded()) {
              <div class="flex-grow-1 ps-3">
                <span>{{ 'LEFT_NAV.ADMIN_TOOLS' | translate }}</span>
              </div>
              <div class="text-center"><i class="fa-light fa-lg fa-chevron-right" aria-hidden="true"></i></div>
            }
          </div>
        </div>
      }
      <div
        ngbDropdown
        id="help-links"
        placement="end"
        #helpDrop="ngbDropdown"
        tabindex="0"
        (focus)="helpDrop.open()"
        (mouseover)="helpDrop.open()"
        (blur)="helpDrop.close()"
        (mouseout)="helpDrop.close()"
        (keydown.enter)="helpDrop.close()"
        (click)="helpDrop.close()"
      >
        <div
          class="d-flex align-items-center flex-row p-2 mx-2 actionable"
          [class.mb-3]="!sideMenuIsExpanded()"
          ngbDropdownToggle
        >
          <div ngbDropdownMenu>
            <a
              class="d-flex align-items-center p-2 mx-2 text-teal2 actionable text-decoration-none"
              id="privacy-statement-link"
              target="_blank"
              href="https://www.omnicell.com/privacy"
              rel="noopener"
            >
              <span class="flex-grow-1">{{ 'LEFT_NAV.PRIVACY_STATEMENT' | translate }}</span>
              <i class="fa-light fa-lg fa-arrow-up-right-from-square" aria-hidden="true"></i>
            </a>
            <a
              class="d-flex align-items-center p-2 mx-2 text-teal2 actionable text-decoration-none"
              id="tncs-link"
              target="_blank"
              href="https://enlivenhealth.co/enlivenhealth-website-terms-and-conditions/"
              rel="noopener"
            >
              <span class="flex-grow-1">{{ 'LEFT_NAV.TS_N_CS' | translate }}</span>
              <i class="fa-light fa-lg fa-arrow-up-right-from-square" aria-hidden="true"></i>
            </a>
          </div>
          <div class="text-center" [class.flex-grow-1]="!sideMenuIsExpanded()">
            <i class="fa-light fa-lg fa-circle-question" aria-hidden="true"></i>
          </div>
          @if (sideMenuIsExpanded()) {
            <div class="flex-grow-1 ps-3">
              <span>{{ 'LEFT_NAV.HELP' | translate }}</span>
            </div>
            <div class="text-center"><i class="fa-light fa-lg fa-chevron-right" aria-hidden="true"></i></div>
          }
        </div>
      </div>
      <div
        [triggers]="'hover'"
        [ngbTooltip]="sideMenuIsExpanded() ? '' : ('LEFT_NAV.SIGN_OUT' | translate)"
        placement="end"
      >
        <div
          (click)="logout()"
          (keydown.enter)="logout()"
          id="sign-out"
          tabindex="0"
          role="button"
          class="d-flex align-items-center flex-row p-2 mx-2 actionable"
        >
          <div class="text-center" [class.flex-grow-1]="!sideMenuIsExpanded()">
            <i class="fa-light fa-arrow-right-from-bracket fa-lg" aria-hidden="true"></i>
          </div>
          @if (sideMenuIsExpanded()) {
            <div class="ps-3">
              <span>{{ 'LEFT_NAV.SIGN_OUT' | translate }}</span>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  <footer class="border-top" id="footer-section">
    <div
      [triggers]="'hover'"
      [ngbTooltip]="sideMenuIsExpanded() ? '' : ('LEFT_NAV.EXPANDED_VIEW' | translate)"
      placement="end"
    >
      <div
        class="d-flex align-items-center flex-row p-2 m-2 actionable"
        (click)="handleSideMenuToggle()"
        (keydown.enter)="handleSideMenuToggle()"
        id="toggler"
        role="button"
        tabindex="0"
      >
        <div class="text-center" [class.flex-grow-1]="!sideMenuIsExpanded()">
          <i
            class="fa-light fa-lg"
            [ngClass]="sideMenuIsExpanded() ? 'fa-arrow-left-to-line ' : 'fa-arrow-right-to-line'"
            id="toggle-icon"
            aria-hidden="true"
          ></i>
        </div>
        @if (sideMenuIsExpanded()) {
          <div class="flex-grow-1 ps-3">
            <span>{{ 'LEFT_NAV.COLLAPSED_VIEW' | translate }}</span>
          </div>
        }
      </div>
    </div>
  </footer>
</nav>

<ng-template #orderedMods let-mods="mods">
  @for (m of mods; track m.id) {
    <div [triggers]="'hover'" [ngbTooltip]="sideMenuIsExpanded() ? '' : m.displayName" placement="end">
      <div
        role="link"
        id="{{ m.displayName }}-link"
        tabindex="0"
        (click)="appClick.emit(m)"
        (keydown.enter)="appClick.emit(m)"
        class="d-flex align-items-center flex-row p-2 mx-2 actionable"
        [ngClass]="{ 'selected': m.active, 'mb-3': !sideMenuIsExpanded() }"
      >
        <div class="text-center" [class.flex-grow-1]="!sideMenuIsExpanded()">
          <i [classList]="m.iconClasses + ' fa-lg'" aria-hidden="true"></i>
        </div>
        @if (sideMenuIsExpanded()) {
          <div class="flex-grow-1 text-break ps-3">
            <span>{{ m.displayName }}</span>
          </div>
          @if (m.type !== EMBEDDED) {
            <div class="text-center">
              <i class="fa-light fa-lg fa-arrow-up-right-from-square" aria-hidden="true"></i>
            </div>
          }
        }
      </div>
    </div>
  }
</ng-template>
